export const colors = {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px', // The boxshadow of the input
    insetShadow: 'inset 0 8px 6px -6px rgba(0, 0, 0, 0.1)', // The inset shadow of the Search-filter component
}

export const bodyCopy = {
    homePgItems: '14px',
    detailPg: '16px',
}

export const breakpoints = {
    mobile: '600px',
    desktop: '1440px',
}
